export const documentConfig = {
  coverLetter: {
    label: 'Cover Letter',
    tooltip: 'Include a tailored cover letter.',
    styles: ['Professional / Corporate', 'Minimalist / Clean', 'Executive / Leadership', 'Bold & Creative']
  },
  cv: {
    label: 'CV',
    tooltip: 'Include an academic/extended CV.',
    styles: ['Professional / Corporate', 'Minimalist / Clean', 'Executive / Leadership', 'Bold & Creative']
  },
  resume: {
    label: 'Resume',
    tooltip: 'Include a resume.',
    styles: ['Professional / Corporate', 'Minimalist / Clean', 'Executive / Leadership', 'Bold & Creative']
  },
  linkedin: {
    label: 'LinkedIn Profile',
    tooltip: 'Include a LinkedIn profile refresh.',
    styles: ['Professional & Polished', 'Executive / Leadership', 'Bold & Creative']
  },
  bio: {
    label: 'Bio',
    tooltip: 'Include a short professional bio.',
    styles: ['Professional & Polished', 'Executive / Leadership', 'Bold & Creative']
  },
  portfolio: {
    label: 'Portfolio',
    tooltip: 'Include a portfolio summary page.',
    styles: ['Bold & Creative', 'Professional & Polished', 'Executive / Leadership']
  }
};

export const sources = [
  {
    key: 'jobDescription',
    label: 'Job Description',
    tooltip: 'No job description? Paste the complete Job Description here when you have one.',
    placeholder: 'Paste full job description...',
    maxLength: 10000,
    required: true
  },
  {
    key: 'service',
    label: 'Service',
    tooltip: 'No Job Description? Add your primary service area (e.g., Operations, IT, Customer Success).',
    placeholder: 'Paste service info...',
    maxLength: 5000
  },
  {
    key: 'industry',
    label: 'Industry',
    tooltip: 'No Job Description? Use industry trends/keywords to tailor your application documents.',
    placeholder: 'Paste industry notes...',
    maxLength: 5000
  },
  {
    key: 'role',
    label: 'Role',
    tooltip: 'Target role information.',
    placeholder: 'Paste role information...',
    maxLength: 5000
  },
  {
    key: 'company',
    label: 'Company',
    tooltip: 'No Job Description? Paste company research: mission, values, product, latest news.',
    placeholder: 'Paste company info...',
    maxLength: 5000
  },
  {
    key: 'other',
    label: 'Other',
    tooltip: 'Additional information.',
    placeholder: 'Paste additional information...',
    maxLength: 5000
  }
];

export const fields = [
  { key: 'date', label: 'DATE' },
  { key: 'company', label: 'COMPANY', maxLength: 100 },
  { key: 'targetJobTitle', label: 'TARGET JOB TITLE', maxLength: 100 },
  { key: 'hiringManager', label: 'HIRING MANAGER', maxLength: 100 },
  { key: 'title', label: 'YOUR CURRENT TITLE', maxLength: 100 },
  { key: 'address', label: 'ADDRESS', placeholder: 'Enter company address', maxLength: 200 }
];

export const docTypeLabels = {
  coverLetter: 'Cover Letter',
  cv: 'CV',
  resume: 'Resume',
  linkedin: 'LinkedIn Profile',
  bio: 'Bio',
  portfolio: 'Portfolio'
};
